import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function getTestsAverageScore(testData) {
	return fetch(
		`${ENDPOINT_URL}/test/avergescores`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				testData,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
